export function throwIfUploadAborted(signal: AbortSignal): void {
  if (signal.aborted) {
    throw uploadAbortError();
  }
}

// ms 동안 기다린다. 중단되면 바로 AbortError 로 끝난다. 이미 중단된 signal 은 abort 이벤트를 다시 내지
// 않는다. 그래서 먼저 확인한다. 확인하지 않으면 대기가 끝날 때까지 잠든다.
export function delayUnlessAborted(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    if (signal.aborted) {
      reject(uploadAbortError());
      return;
    }
    const onAbort = (): void => {
      clearTimeout(timer);
      reject(uploadAbortError());
    };
    const timer = setTimeout(() => {
      signal.removeEventListener("abort", onAbort);
      resolve();
    }, ms);
    signal.addEventListener("abort", onAbort, { once: true });
  });
}

function uploadAbortError(): DOMException {
  return new DOMException("Upload aborted", "AbortError");
}
